import about from './zh/about'
import product from './zh/product'
import matpl from './zh/p_matpl'
import pwmodule from './zh/p_module'
import pwkit from './zh/p_pwkit'
import qflow from './zh/p_qflow'
import qstudio from './zh/p_qstudio'
import allinone from './zh/p_allinone'
import gpu from './zh/download/pwmat'
import ls3df from './zh/download/ls3df'
import potential from './zh/download/potential'
import utility from './zh/download/utility'
import more from './zh/more'

export default{
  ...about,
  ...product,
  ...matpl,
  ...pwmodule,
  ...pwkit,
  ...qflow,
  ...qstudio,
  ...allinone,
  ...gpu,
  ...ls3df,
  ...potential,
  ...utility,
  ...more,
  language: {
    name: 'EN'
  },
  navbar: {
    Home:'首页',
    About:'关于我们',
    CompanyProfile:'公司简介',
    CompanyNews:'公司动态',
    AcademicDemo: '学术教育方案',
    IndustryDemo: '工业行业方案',
    Customers: '合作客户',
    ContactUs:'联系我们',
    JoinUs:'加入我们',
    product:'产品',
    Solution:'软硬一体化',
    Forum:'论坛',
    Video:'视频教程',
    Download:'下载',
    SoftWareDownload:'PWmat',
    PWmatGPU:'GPU 版本',
    PWmatDCU:'DCU 版本',
    PWmatCPU:'CPU 版本',
    PWmatWin:'Windows 版本',
    PWmatTry:'申请试用',
    PotentialDownload:'赝势文件',
    PWmatManual:'PWmat 手册',
    PWmatzhVer:'中文版',
    PWmatenVer:'英文版',
    QflowManual:'Q-Flow 手册',
    QstudioManual:'Q-Studio 手册',
    Course:'资源中心',
    Tutorial:'教程',
    CommonParameter:'常用参数详解',
    TypicalLiterature:'典型文献复现',
    PublishedPapers:'发表论文解读',
    ModuleClassroom:'module 小课堂',
    GettingStartedVideo:'入门教程视频',
    SpecialVideo:'专题课程视频',
    SpecialVideo2:'训练营专题课程视频',
    SpecialVideo3:'Q-Studio 建模小技巧',
    BigVideo:'大咖讲坛视频',
    BigVideo2:'大咖讲坛',
    BigVideo3:'龙讯讲坛',
    BigVideo4:'龙讯研讨班',
    BigVideo5:'会议报告',
    More:'更多',
    Log:'更新日志',
    BugLog: 'Bug 日志',
    Paper:'论文',

  },
  footer:{
    QuickLink:'快速链接',
    FriendlyLink:'友情链接',
    Company:'北京龙讯旷腾科技有限公司',
    JoinUs:'招贤纳士',
    Tutorials:'教程',
    Trial:'试用版',
    forum: '龙讯讲坛',
    link01: '北大新材料',
    phone1: '销售电话：',
    phone2: '市场电话：',
    wechat: '公众号',
    // DeveloplerCenter:'开发者中心',
    // Documentation:'文档',
    // Bounty:'悬赏',
    // SmartX:'SmartX',
    // Github:'Github',
    // Cooperation:'合作',
    // CooperateWithOntology:'与本体合作',
    // TrustEcosystem:'信任生态',
    // Nodes:'节点',
    // About:'关于',
    // Press:'新闻',
    // TechNews:'本体视点',
    // Team:'团队',
    // AboutOntology:'关于本体',
    // WhitePaper:'White Paper',
    // Explorer:'区块链浏览器',
    // dApps:'dApps',
    // dAppsList:'dApps列表',
    // SubmitAdApp:'提交dApp',
  },
  carousel:{
    title1:'第一性原理计算软件 PWmat',
    subtitle1:'电子结构自洽、结构优化、分子动力学、过渡态计算、及基于 PWmat 的各种 module 功能模块',
    button1:'了解更多',
    title2:'PWmat 特色功能',
    title3:'龙讯超算云Mcloud',
    subtitle3:'预装 PWmat、Q-Flow、Q-Studio、PWkit 及其他开源软件',
    button3:'点击注册 Mcloud',
    title4:'机器学习力场软件 MatPL',
    subtitle4:'MatPL 是GNU许可下的开源软件，用于生成与从头算分子动力学精度相当的机器学习力场',
    title5:'PWmat 图形界面 Q-Flow',
    subtitle5:'PWmat 图形化提交任务软件，并且兼具计算、数据存储、数据处理、数据展示等功能',
    title6:'建模软件 Q-Studio',
    subtitle6:'web 端在线原子尺度的材料建模软件，功能丰富，打开浏览器即可使用',
    title7:'原子尺度材料智能计算一体机QStation',
    subtitle7:'精准建模、智慧组合、智能优化、洞悉物性、图谱呈现',
  },
  home: {
    productlist: '产品列表',
    allinone: '一体机',
    about: '超算云',
    mcloud: `Mcloud 是由龙讯旷腾搭建的高性能集群和云桌面组成的超算云平台，云平台集成了PWmat、Q-Flow、Q-Studio以及Lammps等软件，
              提供SaaS材料模拟计算服务，用户 可以自主完成注册，注册之后即可在线使用PWmat等软件和丰富GPU卡时资源。
      `,
    register: '点击注册',
    resource: '资源中心',
    resourcecenter: `资源中心旨在为用户提供丰富的学习资源和参考资料。资源中心汇集了各种形式的教程，
     包括基础教程、案例教程、module课堂、优秀论文解读、视频资料等，帮助用户从基础知识到高级应用各个层面，系统地掌握所需的技能和知识。
     无论是新手还是有经验的专业人士，资源中心都能提供适合的学习路径，助力用户有效学习和提升。`,
    click: '点击查看',
    news: '新闻栏目',
    cooperate: '合作伙伴',
  }
}
